var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Editor from "@/components/Editor";
import { Tabs, Tab } from "@mui/material";
import { FormStyles } from "@/components/styles/FormStyles";
import { CustomTabPanel } from "@/components/CustomTabPanel";
export default function EmailEditor(_a) {
    var record = _a.record, setRecord = _a.setRecord;
    var t = useTranslation().t;
    var _b = useState(0), tab = _b[0], setTab = _b[1];
    var editorRef = useRef(null);
    function handleChange(e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        setRecord(__assign(__assign({}, record), (_a = {}, _a[name] = value, _a)));
    }
    function handleHtmlChange() {
        if (editorRef.current) {
            setRecord(__assign(__assign({}, record), { html_body: editorRef.current.getContent() }));
        }
    }
    var changeTab = function (_event, newValue) {
        setTab(newValue);
    };
    return (_jsxs(_Fragment, { children: [_jsx(FormStyles.TextField, { label: t("emailEditor.subject"), name: "subject", value: record === null || record === void 0 ? void 0 : record.subject, onChange: handleChange }), _jsxs(Tabs, __assign({ value: tab, onChange: changeTab }, { children: [_jsx(Tab, { label: t("emailEditor.tabs.plaintext"), id: "plaintext" }, "plaintext"), _jsx(Tab, { label: t("emailEditor.tabs.richtext"), id: "richtext" }, "richtext")] })), _jsx(CustomTabPanel, __assign({ value: tab, index: 0 }, { children: _jsx(FormStyles.TextField, { name: "plaintext_body", label: t("emailEditor.tabs.plaintext"), value: record === null || record === void 0 ? void 0 : record.plaintext_body, onChange: handleChange, multiline: true, minRows: 6, maxRows: 20 }) }), "plaintext"), _jsx(CustomTabPanel, __assign({ value: tab, index: 1 }, { children: _jsx(Editor, { editorRef: editorRef, initialValue: record.html_body || "", onEditorChange: handleHtmlChange }) }), "richtext")] }));
}
